import styled from "styled-components";
import { FC } from "react";

import Text from "@/components/Text";

const Box = styled.div`
  display: flex;
  align-items: center;
`;

const StyledText = styled(Text)`
  font-size: 11px;
  white-space: nowrap;
`;

const Thumb = styled.img`
  width: 16px;
  height: 16px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

interface Props {
  thumbnail?: string;
  channel: string;
  className?: string;
}

const DistributionChannelBadge: FC<Props> = ({
  className,
  thumbnail,
  channel,
}) => {
  return (
    <Box className={className}>
      {!!thumbnail && <Thumb loading="lazy" src={thumbnail} alt={channel} />}
      <StyledText $type="smallBold">{channel}</StyledText>
    </Box>
  );
};

export default DistributionChannelBadge;
